import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ClearFiltersGI, GetGiAction, ResetClearFiltersGI } from './gi.actions';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';
import { IDetailAtrRespose } from '@/app/core/interfaces/atr.interface';
import { catchError, tap, throwError } from 'rxjs';
import { GiService } from '@/app/core/services/gi/gi.service';

export interface ATRStateModel {
  giData: IDetailAtrRespose[];
  clearFilters: boolean;
}

@State<ATRStateModel>({
  name: 'gi',
  defaults: {
    giData: [],
    clearFilters: false,
  },
})
@Injectable()
export class GiState {
  @Selector() static getGiData(state: ATRStateModel): IDetailAtrRespose[] {
    return state?.giData ? state.giData : [];
  }

  @Selector() static getClearFilters(state: ATRStateModel): boolean {
    return state?.clearFilters || false;
  }

  constructor(
    public dialog: MatDialog,
    private giService: GiService
  ) {}

  @Action(GetGiAction)
  GetGiAction(ctx: StateContext<ATRStateModel>, { payload }: GetGiAction) {
    return this.giService.getGiData(payload).pipe(
      tap(response => {
        ctx.patchState({ giData: response as IDetailAtrRespose[] });
      }),
      catchError(error => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            text: 'Ha ocurrido un error al obtener los datos',
            hiddeCancelBtn: true,
          },
        });
        return throwError(() => error);
      })
    );
  }

  @Action(ClearFiltersGI)
  ClearFiltersGI(ctx: StateContext<ATRStateModel>) {
    ctx.patchState({ clearFilters: true });
  }

  @Action(ResetClearFiltersGI)
  ResetClearFiltersGI(ctx: StateContext<ATRStateModel>) {
    ctx.patchState({ clearFilters: false });
  }
}
